/**
 * Guardia "Contatti/Aziende first-class" (Fase 2 anti-pollution).
 *
 * Esclude le PERSONE-REFERENTE — righe `clients` con `entity_type='individual'`
 * e `stato_cliente IS NULL` — dai contesti dove i clienti/lead vengono LISTATI
 * per selezione, CONTATI o CERCATI. Non sono opportunità/entità di pipeline: sono
 * contatti di aziende (modello Contatti/Aziende first-class).
 *
 * Invarianti: i lead/clienti VERI hanno sempre uno `stato_cliente` valorizzato;
 * le aziende hanno `entity_type='company'`. Quindi il filtro è, per De Morgan:
 *   NOT (entity_type='individual' AND stato_cliente IS NULL)
 *   = entity_type != 'individual' OR stato_cliente IS NOT NULL
 *
 * Uso con supabase-js (PostgREST):
 *   query.or(EXCLUDE_REFERENTI)
 * Combinabile con un `.or(ilike...)` preesistente: i due gruppi OR vengono messi
 * in AND, quindi la ricerca resta corretta e in più esclude i referenti.
 */
export const EXCLUDE_REFERENTI = 'entity_type.neq.individual,stato_cliente.not.is.null';
